<template>
  <v-snackbar v-model="snackbar" :color="status" top>
    {{ text }}
    <template v-slot:action="{ attrs }">
      <v-btn text v-bind="attrs" @click="snackbar = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: 'Snackbar',

  data: () => ({
    snackbar: false,
    status: null,
    text: null
  }),

  created() {
    this.$store.watch(
      state => state.snackbar.snack,
      () => {
        const snack = this.$store.state.snackbar.snack;

        if (snack) {
          this.snackbar = true;

          this.status = snack.status;
          this.text = snack.text;

          this.$store.commit('snackbar/setSnack', null);
        }
      }
    );
  }
};
</script>
